import {
  ArrowIcon,
  CtaButton,
  DisplayHeading,
  Eyebrow,
  INK,
  MUTED,
  Reveal,
} from './ui';

const DIY_ROUTE = [
  'Buy hosting, a domain and a theme — $150+/year before your first word',
  'Shop for plugins to get maps, galleries and an SEO baseline',
  'Build and maintain your destination pages by hand, post by post',
  'Debug a broken site from a hostel with bad WiFi',
  'Start from zero domain authority and wait months for readers',
];

const TF_ROUTE = [
  'Sign up and pick your design — you’re live in minutes',
  'Maps, galleries and itineraries are already in the editor',
  'Pin a post to a place; your destination pages build themselves',
  'Hosting, SSL, CDN and speed handled. Nothing to update, ever',
  'Readers and curation from day one — from $19/year',
];

function CrossIcon() {
  return (
    <svg
      className="tw-mt-1 tw-h-4 tw-w-4 tw-shrink-0 tw-text-[#B0867E]"
      viewBox="0 0 20 20"
      fill="currentColor"
      aria-hidden="true"
    >
      <path
        fillRule="evenodd"
        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
        clipRule="evenodd"
      />
    </svg>
  );
}

function TickIcon() {
  return (
    <svg
      className="tw-mt-1 tw-h-4 tw-w-4 tw-shrink-0 tw-text-primary-200"
      viewBox="0 0 20 20"
      fill="currentColor"
      aria-hidden="true"
    >
      <path
        fillRule="evenodd"
        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default function Comparison({ onJoin }) {
  return (
    <section className="tw-py-20 sm:tw-py-28">
      <div className="tw-mx-auto tw-max-w-6xl tw-px-4 sm:tw-px-6 lg:tw-px-8">
        <Reveal className="tw-mx-auto tw-max-w-3xl tw-text-center">
          <Eyebrow>Two routes, same destination</Eyebrow>
          <DisplayHeading className="tw-text-4xl tw-leading-[1.1] sm:tw-text-5xl">
            Skip the part where blogging becomes a second job.
          </DisplayHeading>
        </Reveal>

        <div className="tw-mt-14 tw-grid tw-grid-cols-1 tw-gap-6 md:tw-grid-cols-2">
          <Reveal>
            <div className="tw-h-full tw-rounded-2xl tw-border tw-border-dashed tw-border-[#C9C0AA] dark:tw-border-[#3A4D44] tw-bg-transparent tw-p-7 sm:tw-p-9 [border-width:1.5px]">
              <p className="tw-mb-1 tw-mt-0 tw-font-mono tw-text-[11px] tw-font-semibold tw-tracking-[0.25em] tw-text-[#9AA59E]">
                ROUTE A · THE LONG WAY ROUND
              </p>
              <p className={`${INK} tw-mb-6 tw-mt-1 tw-text-xl tw-font-semibold`}>
                Do-it-yourself WordPress
              </p>
              <ul className="tw-m-0 tw-flex tw-list-none tw-flex-col tw-gap-4 tw-p-0">
                {DIY_ROUTE.map(item => (
                  <li key={item} className="tw-flex tw-items-start tw-gap-3">
                    <CrossIcon />
                    <span className={`${MUTED} tw-text-[15px] tw-leading-relaxed`}>
                      {item}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>

          <Reveal delay={0.12}>
            <div className="tw-relative tw-h-full tw-overflow-hidden tw-rounded-2xl tw-bg-gradient-to-br tw-from-primary-700 tw-to-[#00362C] tw-p-7 tw-shadow-[0_30px_60px_-20px_rgba(0,105,92,0.5)] sm:tw-p-9">
              <div
                aria-hidden="true"
                className="tw-pointer-events-none tw-absolute -tw-right-10 -tw-top-10 tw-h-44 tw-w-44"
                style={{
                  // Inline: tw-bg-[radial-gradient(...)] doesn't compile in
                  // this repo's Tailwind 3.1.8.
                  background:
                    'radial-gradient(closest-side, rgba(38,166,154,0.3), rgba(38,166,154,0))',
                }}
              />
              <p className="tw-mb-1 tw-mt-0 tw-font-mono tw-text-[11px] tw-font-semibold tw-tracking-[0.25em] tw-text-primary-200">
                ROUTE B · THE DIRECT FLIGHT
              </p>
              <p className="tw-mb-6 tw-mt-1 tw-text-xl tw-font-semibold tw-text-white">
                TravelFeed
              </p>
              <ul className="tw-m-0 tw-flex tw-list-none tw-flex-col tw-gap-4 tw-p-0">
                {TF_ROUTE.map(item => (
                  <li key={item} className="tw-flex tw-items-start tw-gap-3">
                    <TickIcon />
                    <span className="tw-text-[15px] tw-leading-relaxed tw-text-primary-50/95">
                      {item}
                    </span>
                  </li>
                ))}
              </ul>
              <div className="tw-mt-8">
                <CtaButton onClick={onJoin} light>
                  Take the direct flight
                  <ArrowIcon />
                </CtaButton>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
